import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#CEEDFF"
      d="M10 15a10 10 0 1 1 10 10H9a7 7 0 1 1 0-14c.586 0 1.17.071 1.738.213"
    />
    <path
      fill="#80C4FF"
      d="M15.79 4.837A11 11 0 1 1 20 26H9a8 8 0 1 1 .798-15.961l.363.044.106-.208q.178-.338.38-.664l.207-.322a11 11 0 0 1 4.937-4.052m5.966 1.336A9 9 0 0 0 11 15a1 1 0 1 1-2 0 11 11 0 0 1 .322-2.644l.091-.341-.11-.008L9 12a6 6 0 0 0 0 12h11a9 9 0 0 0 1.756-17.827"
    />
  </svg>
);
const SvgIconWeatherCloud = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherCloud);
export default Memo;
